import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { IntlProvider } from "react-intl";
import Tab from "@material-ui/core/Tab";
import Grid from "@material-ui/core/Grid";
import { connect } from "react-redux";
import { CheckActionPermission } from "Actions/commonAction";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import Popover from "@material-ui/core/Popover";
import Paper from "@material-ui/core/Paper";
import MenuListComponent from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Button from "@material-ui/core/Button";
import Tabs from "@material-ui/core/Tabs";
import headersList from "Constants/headersList";
import { Helmet } from "react-helmet";
import PageHeader from "Component/Headers/pageHeader";
// import SearchRound from "Component/Material-ui/SearchRound";

import {
  List,
  TDTypeConsts,
  CreateComp,
} from "Module/Subscription/business-configration/commons";
import { instance } from "Actions/AxiosInstance";
import emptylist from "Assets/Svg/illustration-no-policy.svg";
import VARIBALES from "../PipelineMailTemplates/variables";
import Create from "./create";
import CustomLoader from "Component/CustomLoader";

let global = [];
let shouldCallAPI = true;
class JobsCreation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
      modules2: {
        toolbar: {
          container: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike"],
            ["blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            ["clean"],
            [{ placeholder: [] }],
          ],
          handlers: {
            placeholder(value) {
              console.log("this: ", this);
              const obj = global.find((x) => x.displayname == value);
              if (value) {
                const cursorPosition = this.quill.getSelection().index;
                this.quill.insertText(cursorPosition, `{${obj.variablevalue}}`);
                this.quill.setSelection(
                  cursorPosition + obj.variablevalue.length + 2,
                );
              }
            },
          },
        },
      },
      listdata: [],
      offset: 0,
      limit: 10,
      value: 0,
      data: false,
      // postData: null,
      copypolicy: null,
      nofuel: false,
      selectedRow: null,
      headers: [
        {
          key: "name",
          name: "Pipeline name",
          type: TDTypeConsts.EXPENSE_POLICY_NAME,
          style: { textAlign: "left" },
        },
        {
          key: "noofstage",
          name: "Number of stages",
          type: TDTypeConsts.OTHERS,
          style: { textAlign: "center" },
        },
        {
          key: "imagepath",
          name: "Created By",
          type: TDTypeConsts.CREATED_BY,
        },
        {
          key: "isactive",
          name: "Status",
          type: TDTypeConsts.STATE_ACTIVE_INACTIVE,
        },
        {
          key: "moreoptions",
          type: TDTypeConsts.MORE_OPTIONS,
        },
      ],
    };

    this.getPipeline = this.getPipeline.bind(this);
    this.renderList = this.renderList.bind(this);
    this.onCreate = this.onCreate.bind(this);
    this.create = this.create.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.conFirmDelete = this.conFirmDelete.bind(this);
    this.onMoreOptionClick = this.onMoreOptionClick.bind(this);
    this.createNewMenuClose = this.createNewMenuClose.bind(this);
  }

  componentWillMount() {
    if (this.props.history.location.pathname.includes("create")) {
      this.props.history.push(`${this.props.match.path}/list`);
    }
  }

  handleScroll1 = () => {
    const windowBottom =
      Math.floor(window.innerHeight * 0.65) + window.pageYOffset;
    if (windowBottom >= Math.floor(window.innerHeight * 0.65)) {
      if (shouldCallAPI) {
        if (this.state.fullcount > this.state.offset) {
          shouldCallAPI = false;
          this.setState(
            {
              offset: this.state.offset + 10,
            },
            () => this.callAllLeavePolicy(),
          );
          setTimeout(() => {
            shouldCallAPI = true;
          }, 5000);
        } else {
          this.setState({
            message: "no data",
          });
        }
      }
    }
  };

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("pipeline");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getPipeline(true, false);
        if (!this.state.permissions.editable) {
          const index =
            this.state.headers &&
            this.state.headers.findIndex(
              (x) => x.type == TDTypeConsts.MORE_OPTIONS,
            );
          if (index != -1) {
            this.state.headers && this.state.headers.splice(index, 1);
          }
        }
        if (!this.state.permissions.editable) {
          const index =
            this.state.headers &&
            this.state.headers.findIndex(
              (x) => x.type == TDTypeConsts.STATE_ACTIVE_INACTIVE,
            );
          if (index != -1) {
            this.state.headers && this.state.headers.splice(index, 1);
          }
        }
      });

      if (this.props.history.location.pathname.includes("create")) {
        this.props.history.push(`${this.props.match.path}`);
      }
    } else {
      this.setState({ permissiondenied: true });
    }

    this.getLetterVariables();
  }

  getPipeline(isactive, isdraft) {
    const { value } = this.state;
    this.setState({isLoading:true}, () => {
      instance
      .post(`recruit/getallpipeline`, {
        isactive: value == 0 ? true : false,
        isdraft: value == 0 ? false : true,
        // limit: 10,
        // offset: 0,
      })
      .then((resp) => {
        console.log("resp: ", resp.data.result);
        this.setState({
          listdata: resp.data.result,
          data: true,
          createmenu: false,
          isLoading:false
        });
      })
      .catch((error) => {
        this.setState({isLoading: false})
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
    })
   
  }

  create() {
    return (
      !this.state.nofuel && (
        <Create
          {...this.props}
          {...this.state}
          // tempdata={tempdata}
          getPipeline={this.getPipeline}
        />
      )
    );
  }

  async onCreate() {
    const postData = {
      pipelineid: null,
      name: null,
      description: null,
      isdraft: false,
      isactive: true,
      noofstage: 0,
      pipelinestage: [],
    };
    this.setState(
      {
        // newpolicycreate: true,
        postData,
      },
      () => {
        this.props.history.push(`${this.props.match.path}/create`);
      },
    );
  }

  onEdit() {
    const { selectedRow } = this.state;
    this.setState({ createmenu: false });
    instance
      .get(`/recruit/getpipeinebyid/${selectedRow.pipelineid}`)
      .then((resp) => {
        console.log(resp.data.result[0]);
        this.setState(
          { postData: resp.data.result[0], createmenu: false },
          () => {
            this.props.history.push(`${this.props.match.url}/create`);
          },
        );
      });
  }

  getLetterVariables() {
    instance
      .get("superuser/getlettervariablelist/6")
      .then((result) => {
        const { modules2 } = this.state;
        modules2.toolbar.container[6][0].placeholder = result.data.result
          .filter((x) => !x.iscustom && x.displayvalue != VARIBALES.signatory)
          .map((x) => x.displayname);
        console.log(
          "modules.toolbar.container[6][0].placeholder: ",
          modules2.toolbar.container[6][0].placeholder,
        );
        this.setState(
          {
            letterVariables:
              result.data.result.filter((x) => !x.iscustom) || [],
            modules2,
          },
          () => {
            console.log(this.state.modules2);
            global = this.state.letterVariables;
          },
        );
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  conFirmDelete() {
    const { selectedRow } = this.state;
    this.setState({ createmenu: false });
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          color="inherit"
          size="small"
          onClick={() => this.onDelete(selectedRow.pipelineid)}
        >
          Yes
        </Button>,
        <Button
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  }

  onDelete(id) {
    instance.post(`recruit/deletepipeline`, { pipelineid: id }).then(
      (result) => {
        this.props.enqueueSnackbar("Deleted successfully", {
          variant: "success",
        });
        this.props.closeSnackbar();
        this.setState(
          {
            backupList: [],
            totalcount: 1,
            data: [],
            offset: 0,
            createmenu: false,
          },
          () => {
            this.getPipeline();
          },
        );
      },
      (error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      },
    );
  }

  onStateStatusChange = (value, selectedRow) => {
    const data = {
      pipelineid: selectedRow.pipelineid ? selectedRow.pipelineid : null,
      isactive: value == 1 ? true : false,
    };

    this.props.enqueueSnackbar(
      "Are you sure you want to change status of this piepline?",
      {
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => {
              // const { selectedRow } = this.state;
              this.props.closeSnackbar();
              instance
                .post("recruit/activeinactivepipeline", data)
                .then((res) => {
                  this.setState(
                    {
                      isActive: res.data.result,
                    },
                    () => this.getPipeline(),
                  );
                });
            }}
          >
            Yes
          </Button>,

          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => this.props.closeSnackbar()}
          >
            No
          </Button>,
        ],
      },
    );
  };

  onMoreOptionClick(event, row) {
    this.setState({
      createmenu: !this.state.createmenu,
      create_anchorEl: event.currentTarget,
      selectedRow: row,
    });
  }

  createNewMenuClose() {
    this.setState({ createmenu: false });
  }

  renderList() {
    const { value } = this.state;
    return (
      this.state.data && (
        <div className="innerwrapper-full-width">
          <div className="common-menubar-header">
            <Tabs
              value={this.state.value}
              indicatorColor="#fff"
              textColor="primary"
              scrollButtons="auto"
            >
              <Tab
                label="Saved"
                className={`tabheading ${
                  this.state.value == 0 ? "active-tab1" : "inactive-tab1"
                } `}
                onClick={() =>
                  this.setState({ value: 0 }, () => this.getPipeline())
                }
              />
              <Tab
                label="Drafts"
                className={`tabheading ${
                  this.state.value == 1 ? "active-tab1" : "inactive-tab1"
                } `}
                onClick={() =>
                  this.setState({ value: 1 }, () => {
                    this.getPipeline();
                  })
                }
              />
            </Tabs>
            <div className="tab-border"></div>
          </div>
          {this.state.isLoading ? 
          <div className="content-outer-wrapper-with-tab">
          <CustomLoader/> 
          </div>
        :  <div>
          {this.state.listdata.length > 0 ? (
            <div className="content-outer-wrapper-with-tab">
              <Grid container>
                <Grid item xs={12} md={2} sm={2}>
                  <p className="large-text-dark-secondary margin-bottom-16 t-bold">
                    Pipeline setup
                  </p>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={10}
                  sm={2}
                  justify="flex-end"
                  className="display-flex"
                >
                  <div>
                    {/* <div className="floatleft margin-right-16">
                      <SearchRound
                        placeholder="Search"
                        value={this.state.searchValue}
                        onChange={this.handleSearch}
                      />
                    </div> */}

                    {/* {this.state.permissions.editable && (
                      <span className="floatleft">
                        <Button
                          variant="contained"
                          className="btn btn-primary-md-blue"
                          color="primary"
                          onClick={this.onCreate}
                        >
                          Create pipeline
                        </Button>
                      </span>
                    )} */}
                  </div>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item sm={12} md={12}>
                  <List
                    onCreate={this.onCreate}
                    list={this.state.listdata}
                    headers={this.state.headers}
                    permissions={this.state.permissions}
                    onEdit={this.onEdit}
                    onDelete={this.conFirmDelete}
                    module="pipeline"
                    onStateStatusChange={this.onStateStatusChange}
                    onMoreOptionClick={(e, row) =>
                      this.onMoreOptionClick(e, row)
                    }
                  />
                </Grid>
              </Grid>
              <Popover
                open={this.state.createmenu}
                anchorEl={this.state.create_anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                onClose={() => this.setState({ createmenu: false })}
                className="margin-top-8"
              >
                <Paper style={{ width: 190 }}>
                  <div>
                    <MenuListComponent>
                      <ListItem
                        className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                        onClick={this.onEdit}
                      >
                        <ListItemText style={{ padding: 0 }}>
                          <span className="small-dark-secondary">Edit</span>
                        </ListItemText>
                      </ListItem>
                      {/* <ListItem
                        className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                      // onClick={this.onDuplicate}
                      >
                        <ListItemText style={{ padding: 0 }}>
                          <span className="small-dark-secondary">
                            Duplicate
                          </span>
                        </ListItemText>
                      </ListItem> */}
                      <ListItem
                        className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                        onClick={this.conFirmDelete}
                      >
                        <ListItemText style={{ padding: 0 }}>
                          <span className="small-dark-secondary">Delete</span>
                        </ListItemText>
                      </ListItem>
                    </MenuListComponent>
                  </div>
                </Paper>
              </Popover>
            </div>
          ) : (
            <div className="content-outer-wrapper-with-tab">
              <CreateComp
                text={
                  this.state.value == 0
                    ? "Get started by creating your first pipeline!"
                    : "Saved drafts allow you to store pipeline that you have not finished creating."
                }
                heading={
                  this.state.value == 0
                    ? "There are no pipelines to display"
                    : "No drafts saved"
                }
                onCreate={this.onCreate}
                imageSrc={emptylist}
                permissions={this.state.permissions}
              />
            </div>
          )}
          </div>
           }
        </div>
      )
    );
  }

  render() {
    const { match } = this.props;
    return (
      <div>
        <IntlProvider locale="en">
          <div>
            <Helmet>
              <title>{headersList.Config.ATS.Pipeline.header}</title>
            </Helmet>
            {this.state.permissiondenied ? (
              <div className="position-rel">
                <PermissionDeniedComp />
              </div>
            ) : (
              <div>
                {this.state.data && (
                  <div>
                    <div>
                      <Switch>
                        <Route
                          exact
                          path={`${match.path}`}
                          render={this.renderList}
                        />
                        <Route
                          exact
                          path={`${match.path}/create`}
                          render={this.create}
                        />
                        <Redirect from={`${match.path}`} to={`${match.path}`} />
                      </Switch>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </IntlProvider>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SubscriptionInfo: state.SubscriptionInfo,
  loginData: state.AuthenticationAction.login,
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withSnackbar(JobsCreation)),
);
